import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GenericDialogComponent } from '../components/dialog/dialog';

@Injectable()
export class GlobalErrorInterceptor implements HttpInterceptor {
  constructor(private dialog: MatDialog) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        if (req.url.includes('/auth/login')) {
          // Do not show dialog for login errors, just rethrow
          return throwError(() => error);
        }

        let title = 'Greška';
        let message = 'Došlo je do neočekivane greške u sustavu. Molimo Vas kontaktirajte tehničkog administratora.';

        if (error.error && typeof error.error === 'object' && (error.error.title || error.error.detail)) {
          title = error.error.title || title;
          message = error.error.detail || message;
        } else if (error.message) {
          message = error.message;
        }

        this.dialog.open(GenericDialogComponent, {
          data: {
            title: title,
            message: message,
            confirmButtonText: 'U redu'
          },
          width: '50%',
          disableClose: true
        });

        return throwError(() => error);
      })
    );
  }
}